var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    {
      staticClass: "row-cols-2 row-cols-md-3 row-cols-lg-1 row-cols-xl-3",
      attrs: { "align-h": "center" },
    },
    [
      _c(
        "b-col",
        { staticClass: "px-md-1" },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "info" },
            },
            [
              _c("strong", [_vm._v("To Fit")]),
              _c("br"),
              !_vm.artworkDimensions.name
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.artworkDimensions.width) +
                        "x" +
                        _vm._s(_vm.artworkDimensions.length) +
                        "mm"
                    ),
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.artworkDimensions.name))]),
              _c("br"),
              _c("small", [_c("em", [_vm._v("As entered")])]),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "px-md-1" },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "success" },
            },
            [
              _c("strong", [_vm._v("Visible")]),
              _c("br"),
              !_vm.hasMount
                ? _c("div", { staticClass: "rebate-size" }, [
                    _vm._v(
                      _vm._s(_vm.visibleInternalDimensions.width) +
                        "x" +
                        _vm._s(_vm.visibleInternalDimensions.length) +
                        "mm"
                    ),
                    _c("br"),
                    _c("small", [_c("em", [_vm._v("Approximate")])]),
                  ])
                : _c("div", { staticClass: "aperture-size" }, [
                    _vm._v(
                      _vm._s(_vm.apertureDimensions.width) +
                        "x" +
                        _vm._s(_vm.apertureDimensions.length) +
                        "mm"
                    ),
                    _c("br"),
                    _c("small", [_c("em", [_vm._v("Mount Aperture")])]),
                  ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "px-md-1" },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "danger" },
            },
            [
              _vm.hasMount
                ? [
                    _c("strong", [_vm._v("Glass / Backing")]),
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.glassDimensions.width) +
                        "x" +
                        _vm._s(_vm.glassDimensions.length) +
                        "mm"
                    ),
                    _c("br"),
                    _c("small", [_c("em", [_vm._v("Including mount")])]),
                  ]
                : [
                    _c("strong", [_vm._v("Rebate")]),
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.rebateDimensions.width) +
                        "x" +
                        _vm._s(_vm.rebateDimensions.length) +
                        "mm"
                    ),
                    _c("br"),
                    _c("small", [_c("em", [_vm._v("From back")])]),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }